import { render, staticRenderFns } from "./ProductRegistration.vue?vue&type=template&id=324bfae1&scoped=true"
import script from "./ProductRegistration.vue?vue&type=script&lang=js"
export * from "./ProductRegistration.vue?vue&type=script&lang=js"
import style0 from "./ProductRegistration.vue?vue&type=style&index=0&id=324bfae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324bfae1",
  null
  
)

export default component.exports